module.exports = __webpack_public_path__ + "static/mobalum1-9dbb0c57a87875e71489f7bf5df55809.png";